﻿export interface ICenterFollowUpLabOption {
     id: number,
     centerId: number,
     isLabOrdersOrPrintableLetters: boolean,
     isFollowUpNeeded: boolean,
     isDeleted: boolean,
     optionText: string,
     filePath: string
}
